<template>
  <div style="width: 100%;">
    <v-card :style="{ backgroundColor: $ajustes.colorElemento }" elevation="1" class="line" :disabled="loading"
      :loading="loading">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear :active="isActive" color="deep-purple" height="4" indeterminate></v-progress-linear>
      </template>
      <v-img height="200px" :src="`${$env.pathImg}/${propCurso.imagen_ruta}`" cover>
        <h3 v-if="propCurso.destacado == 1"
          style="position: absolute; color: gold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;"
          class="ma-1">
          <v-icon class="mb-1" color="gold" small>mdi-star-circle</v-icon>
          DESTACADO
        </h3>

      </v-img>
      <v-container style="height: 55px; overflow: hidden;">
        <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">{{ propCurso.titulo }}</h1>
      </v-container>
      <v-container style="height: 125px;">
        <span style="font-size: small;">{{ propCurso.detalles }}</span>
      </v-container>
      <v-container>
        <span style="font-size: small;"><strong>Modalidad: </strong>{{ propCurso.modalidad }}</span>
        <span style="font-size: small;"><strong>Duración: </strong>{{ propCurso.duracion }}</span>
        <span style="font-size: small;"><strong>Inicio: </strong>{{ propCurso.fecha_inicio }}</span>
        <h3 v-if="propCurso.enlace.length>5">
          Más información:
          <a :href="propCurso.enlace" target="_blank" rel="noopener" class="pointer"
            style="font-weight: normal; color: blue; text-decoration: underline;">
            Click aquí
          </a>
        </h3>
      </v-container>
      <v-card-actions>
        <v-btn dark rounded :color="$ajustes.colorTexto2" :style="{ color: $ajustes.colorTexto1 }" block border
          style="text-transform: none; font-size: large;"
          @click="accion(propCurso.id, propCurso.titulo)">Inscribirse</v-btn>
      </v-card-actions>
      <br>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    propCurso: { type: Object },
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
  },

  created() { },
  computed: {},
  methods: {
    accion(id, titulo) {
      this.$emit("propAccion", id, titulo);
    }
  },
  continuar() { },
  close() { },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
